module.exports = __webpack_public_path__ + "img/hr-roboport-base-animation.1811030b.png";